var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "async-task-manage" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "任务类型", clearable: "" },
              model: {
                value: _vm.listQuery.taskType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "taskType", $$v)
                },
                expression: "listQuery.taskType",
              },
            },
            _vm._l(_vm.taskTypeOptions, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "任务状态", clearable: "" },
              model: {
                value: _vm.listQuery.status,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "status", $$v)
                },
                expression: "listQuery.status",
              },
            },
            [
              _c("el-option", { attrs: { label: "待执行", value: "0" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "执行中", value: "1" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "成功", value: "2" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "失败", value: "3" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "已取消", value: "4" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "业务类型", clearable: "" },
              model: {
                value: _vm.listQuery.businessType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "businessType", $$v)
                },
                expression: "listQuery.businessType",
              },
            },
            _vm._l(_vm.businessTypeOptions, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "150px" },
            attrs: { placeholder: "业务ID", clearable: "" },
            model: {
              value: _vm.listQuery.businessId,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "businessId", $$v)
              },
              expression: "listQuery.businessId",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v("\n        搜索\n      ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "default", icon: "el-icon-refresh" },
              on: { click: _vm.handleReset },
            },
            [_vm._v("\n        重置\n      ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.taskList,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "任务ID",
              prop: "taskId",
              align: "center",
              width: "80",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "任务类型",
              prop: "taskType",
              align: "center",
              width: "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.getTaskTypeConfig(row.taskType).label) +
                        "\n        "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "业务类型",
              prop: "businessType",
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.getBusinessTypeConfig(row.businessType).label
                        ) +
                        "\n        "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "业务ID",
              prop: "businessId",
              align: "center",
              width: "100",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "状态",
              prop: "status",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.status === "pending"
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", size: "small" } },
                          [_vm._v("待执行")]
                        )
                      : row.status === "running"
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warning", size: "small" } },
                          [
                            _c("i", { staticClass: "el-icon-loading" }),
                            _vm._v(" 执行中\n          "),
                          ]
                        )
                      : row.status === "completed"
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", size: "small" } },
                          [_vm._v("已完成")]
                        )
                      : row.status === "failed"
                      ? _c(
                          "el-tag",
                          { attrs: { type: "danger", size: "small" } },
                          [_vm._v("执行失败")]
                        )
                      : row.status === "cancelled"
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", size: "small" } },
                          [_vm._v("已取消")]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { type: "info", size: "small" } },
                          [_vm._v(_vm._s(row.status))]
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "耗时", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.costTime
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.formatTime(row.costTime))),
                        ])
                      : row.status === "running"
                      ? _c("span", { staticStyle: { color: "#E6A23C" } }, [
                          _vm._v("执行中..."),
                        ])
                      : _c("span", { staticStyle: { color: "#909399" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作人",
              prop: "operator",
              align: "center",
              width: "100",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "创建时间", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.createTime
                      ? _c("span", [_vm._v(_vm._s(row.createTime))])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "错误信息", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.errorMessage
                      ? _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top",
                              width: "400",
                              trigger: "hover",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "#F56C6C",
                                  cursor: "pointer",
                                },
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _c("i", { staticClass: "el-icon-warning" }),
                                _vm._v(" 查看错误\n            "),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "max-height": "300px",
                                  "overflow-y": "auto",
                                  "word-break": "break-all",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(row.errorMessage) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _c("span", { staticStyle: { color: "#909399" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: "操作",
              align: "center",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.status === "running"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "mini",
                              icon: "el-icon-video-pause",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleCancelTask(row)
                              },
                            },
                          },
                          [_vm._v("\n            取消\n          ")]
                        )
                      : row.status === "failed"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "warning",
                              size: "mini",
                              icon: "el-icon-refresh",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleRetryTask(row)
                              },
                            },
                          },
                          [_vm._v("\n            重试\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-view",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleViewDetail(row)
                          },
                        },
                      },
                      [_vm._v("\n            详情\n          ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.listQuery.page,
              "page-size": _vm.listQuery.size,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.detailDialogVisible,
            title: "任务详情",
            width: "800px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _vm.currentTask
            ? _c(
                "div",
                [
                  _c(
                    "el-descriptions",
                    { attrs: { column: 2, border: "" } },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "任务ID" } },
                        [_vm._v(_vm._s(_vm.currentTask.taskId))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "任务类型" } },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.getTaskTypeConfig(
                                  _vm.currentTask.taskType
                                ).tagType,
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.getTaskTypeConfig(
                                      _vm.currentTask.taskType
                                    ).label
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "业务ID" } },
                        [_vm._v(_vm._s(_vm.currentTask.businessId || "-"))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "业务类型" } },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.getBusinessTypeConfig(
                                  _vm.currentTask.businessType
                                ).tagType,
                                size: "mini",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.getBusinessTypeConfig(
                                      _vm.currentTask.businessType
                                    ).label
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "状态" } },
                        [
                          _vm.currentTask.status === "pending"
                            ? _c("el-tag", { attrs: { type: "info" } }, [
                                _vm._v("待执行"),
                              ])
                            : _vm.currentTask.status === "running"
                            ? _c("el-tag", { attrs: { type: "warning" } }, [
                                _vm._v("执行中"),
                              ])
                            : _vm.currentTask.status === "completed"
                            ? _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v("已完成"),
                              ])
                            : _vm.currentTask.status === "failed"
                            ? _c("el-tag", { attrs: { type: "danger" } }, [
                                _vm._v("执行失败"),
                              ])
                            : _vm.currentTask.status === "cancelled"
                            ? _c("el-tag", { attrs: { type: "info" } }, [
                                _vm._v("已取消"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-descriptions-item", { attrs: { label: "进度" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.currentTask.progress) +
                            "% (" +
                            _vm._s(_vm.currentTask.current || 0) +
                            " / " +
                            _vm._s(_vm.currentTask.total || 0) +
                            ")\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-descriptions-item", { attrs: { label: "耗时" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.currentTask.costTime
                                ? _vm.formatTime(_vm.currentTask.costTime)
                                : "-"
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "操作人" } },
                        [_vm._v(_vm._s(_vm.currentTask.operator || "-"))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "创建时间" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.currentTask.createTime || "-") +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "开始时间" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.currentTask.startTime || "-") +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "结束时间" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.currentTask.endTime || "-") +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.currentTask.status === "running" ||
                  _vm.currentTask.status === "completed"
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "20px" } },
                        [
                          _c("el-progress", {
                            attrs: {
                              percentage: _vm.currentTask.progress || 0,
                              status:
                                _vm.currentTask.status === "completed"
                                  ? "success"
                                  : undefined,
                              "text-inside": true,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentTask.errorMessage
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "20px" } },
                        [
                          _c(
                            "el-alert",
                            {
                              attrs: {
                                title: "错误信息",
                                type: "error",
                                closable: false,
                                "show-icon": "",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.currentTask.errorMessage) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentTask.params
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "20px" } },
                        [
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("任务参数")]
                          ),
                          _vm._v(" "),
                          _c(
                            "pre",
                            {
                              staticStyle: {
                                background: "#f5f7fa",
                                padding: "10px",
                                "border-radius": "4px",
                                "overflow-x": "auto",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.formatParams(_vm.currentTask.params))
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _vm.currentTask && _vm.currentTask.status === "running"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          return _vm.handleCancelTask(_vm.currentTask)
                        },
                      },
                    },
                    [_vm._v("\n          取消任务\n        ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }